import React from 'react';
import { Row as AntRow } from 'antd';
import type { RowProps } from 'antd';
import clsx from 'clsx';

export const Row = ({ className, ...props }: RowProps) => (
  <AntRow {...props} className={clsx('wk-row', className)} />
);
